import axios from 'axios'
import { apiBaseUrl } from '../const'
import {
  canRefreshActiveToken,
  getActiveToken,
  isTokenExpired,
  isTokenExpiredBeyondRefreshGrace,
  markAuthSessionActive,
  persistActiveToken,
} from './forceLogout'

let refreshPromise: Promise<string | null> | null = null

export const refreshActiveToken = async (options?: { force?: boolean }): Promise<string | null> => {
  const currentToken = getActiveToken()
  const force = options?.force === true

  if (!currentToken || !canRefreshActiveToken()) {
    return null
  }

  if (isTokenExpiredBeyondRefreshGrace(currentToken)) {
    return null
  }

  if (!force && !isTokenExpired(currentToken)) {
    return currentToken
  }

  if (refreshPromise) {
    return refreshPromise
  }

  refreshPromise = (async () => {
    try {
      const response = await axios.post(
        `${apiBaseUrl}/admins/refresh-token`,
        {},
        {
          headers: {
            Authorization: `Bearer ${currentToken}`,
          },
        },
      )

      const token = response.data?.token
      if (typeof token !== 'string' || !token) {
        return null
      }

      persistActiveToken(token)
      markAuthSessionActive()
      return token
    } catch {
      return null
    } finally {
      refreshPromise = null
    }
  })()

  return refreshPromise
}
